/* FiveStarBoxing customiser: full set, gloves only, headgear only or groin guard only (data-mode). Static file, no Liquid.
   Names and logos are layers: customers can add as many as they like, drag each one on the preview, resize it or remove it.
   Gloves-only page: a first "Base" step picks the glove drawing (Japanese Ribbed Wrist, Japanese Flat Wrist or Crosses); the Crosses base has 7 crosses coloured one by one. */
(function () {
  var root = document.getElementById('fsbs');
  if (!root) return;
  var ART = window.FSBS_ART;
  if (!ART) return;
  var MODE = root.getAttribute('data-mode') || 'set';
  var form = document.getElementById('fsbs-form');
  var VARIANTS = [];
  try { VARIANTS = JSON.parse(document.getElementById('fsbs-variants').textContent) || []; } catch (e) {}
  // variant title = number of embroidered items ("None", "1 item"...); the glove product uses "Print" / "Embroidered"
  VARIANTS.forEach(function (v) { v.n = parseInt(v.title, 10) || (/embroider/i.test(v.title) ? 1 : 0); });
  VARIANTS.sort(function (a, b) { return a.n - b.n; });
  var MAXN = VARIANTS.length ? VARIANTS[VARIANTS.length - 1].n : 0;
  var FLAT = MAXN === 1; // one embroidery charge covers every embroidered name and logo
  var EMB_EXTRA = root.getAttribute('data-emb-extra') || '';
  var EMB_LABEL = EMB_EXTRA ? '+' + EMB_EXTRA + (FLAT ? (MODE === 'glove' ? ' per pair' : ' once') : '') : '';

  var ASSETS = {
    atlas: 'https://cdn.shopify.com/s/files/1/0708/2157/6926/files/fsb-glove-atlas.png?v=1783243302',
    det: 'https://cdn.shopify.com/s/files/1/0708/2157/6926/files/fsb-glove-detail.png?v=1783240718',
    logo: 'https://cdn.shopify.com/s/files/1/0708/2157/6926/files/fsb-logo.png?v=1783240740'
  };
  // Crosses base: the drawing (Shopify Files) is turned into dark lines on a see-through background once it loads
  // (Shopify serves it compressed, so its white isn't pure white) and goes on top of the colour areas.
  // Colour areas are SVG paths in the cropped drawing's coordinates (tw x th, crop starts at sx,sy in the image).
  // patch = where the drawing says "14 oz": painted over because customers pick their own weight.
  // logo/name = where new logos/names start.
  var CROSSES = {
    url: 'https://cdn.shopify.com/s/files/1/0708/2157/6926/files/Untitled_design_-_2026-11-03T185915.132.png?v=1793693916',
    sx: 47, sy: 149, tw: 756, th: 799, patch: [151, 182, 122, 46],
    crosses: [['cross_1', 'Lace Side Left', '#ffffff'], ['cross_2', 'Lace Side Right', '#ffffff'], ['cross_3', 'Cuff Top Left', '#ffffff'],
      ['cross_4', 'Cuff Bottom Left', '#ffffff'], ['cross_5', 'Cuff Centre', '#ffffff'], ['cross_6', 'Cuff Top Right', '#ffffff'],
      ['cross_7', 'Cuff Bottom Right', '#ffffff']],
    logo: [598, 204, 166, 139], name: [598, 389, 220, 39],
    zones: {
      glove_top: 'M474 29l-9 7 -6 7 -6 10 -4 11 -2 10 -1 24 1 1 1 14 2 2 0 13 2 3 0 10 2 2 0 5 5 10 0 3 3 4 7 22 0 6 1 1 -2 12 -3 3 0 3 -2 3 -1 14 -2 4 -2 48 1 1 0 21 1 1 0 12 2 9 1 24 1 1 0 7 2 9 1 20 3 15 0 8 4 21 -2 3 0 3 2 3 4 14 1 23 9 3 20 2 8 2 10 0 1 1 18 0 1 1 103 0 1 -1 30 -1 7 -2 23 -2 17 -4 1 -1 -1 -3 1 -1 0 -20 1 -1 3 -63 1 -1 0 -11 1 -1 0 -9 1 -1 1 -31 1 -1 3 -45 1 -1 0 -10 1 -1 0 -10 1 -1 2 -59 1 -1 0 -41 2 -7 -1 -4 1 -4 0 -41 -1 -1 0 -9 -5 -20 -7 -15 -13 -14 -19 -12 -22 -8 -4 0 -8 -3 -7 0 -1 -1 -20 -2 -1 -1 -49 -3 -1 -1 -75 0 -20 4zM78 36l-13 14 -3 5 -4 12 -1 19 -1 1 0 19 2 9 0 12 3 9 9 -1 1 -1 0 -5 3 -5 6 -6 10 -2 7 8 0 2 4 7 9 10 10 5 9 7 10 4 16 4 6 -1 2 2 6 2 8 0 5 -2 4 3 10 2 9 0 8 -2 4 1 17 0 3 -2 14 0 1 -1 10 -1 10 -4 10 -7 3 0 4 -2 11 -9 4 -5 2 -5 3 -3 3 -1 8 -10 6 -1 3 -2 9 0 8 6 4 6 3 7 1 6 2 3 0 6 2 5 -1 15 2 3 -1 132 -1 1 0 28 -1 1 0 25 -1 1 0 18 4 4 2 -35 1 -1 2 -71 1 -1 -1 -110 1 -1 1 -46 1 -5 -2 -8 0 -5 1 -1 -1 -14 -3 -14 -4 -10 -8 -12 -11 -11 -7 -5 -27 -13 -18 -4 -4 -2 -5 0 -7 -2 -22 -2 -1 -1 -17 0 -1 -1 -60 0 -1 1 -15 0 -1 1 -8 0 -6 2 -5 0 -10 2 -20 7 -15 8z',
      palm: 'M328 584l0 13 1 1 1 21 1 1 0 9 1 1 3 32 3 9 4 5 2 0 1 -2 0 -11 1 -1 2 -74 -9 -3zM98 584l-9 1 -13 5 1 62 1 1 0 23 1 4 4 -2 5 -7 4 -14 4 -47 1 -1 0 -11 1 -1zM340 114l-13 0 -9 3 -6 8 -7 5 -2 5 -7 8 -9 7 -9 3 -10 7 -8 3 -10 1 -1 1 -10 -1 -7 3 -21 -1 -1 1 -12 1 -10 -2 -4 -3 -13 2 -4 -1 -4 -3 -5 0 -1 1 -16 -4 -10 -4 -9 -7 -10 -5 -10 -11 -4 -7 0 -2 -6 -7 -14 2 -8 10 0 8 5 0 8 3 6 6 1 5 4 6 1 12 -2 8 0 21 -1 1 -1 20 -1 1 0 11 1 1 1 13 2 8 3 6 6 4 5 7 0 2 6 10 3 7 1 10 2 3 0 5 2 2 -1 5 2 2 -1 1 1 5 0 22 -2 8 0 8 -9 38 -16 41 -2 2 -1 4 -11 20 0 2 -6 8 0 11 -1 1 0 11 1 1 0 53 -1 1 10 5 6 2 5 0 0 -7 -2 -5 -11 -14 -1 -5 7 -5 8 -1 7 -10 6 -4 8 7 4 6 10 2 5 4 -1 5 -11 16 -2 10 2 1 5 -1 8 -4 8 -6 7 -3 5 5 3 11 6 5 3 5 -1 4 -9 9 -2 11 -3 3 -3 0 -7 -5 -2 0 -11 -6 -10 -1 6 76 2 8 3 6 5 6 0 3 -5 4 -10 1 -12 14 -3 0 -6 -6 -5 -8 -8 -1 -10 -5 0 27 15 9 6 1 7 3 16 2 1 1 41 2 3 -3 0 -8 5 -6 4 0 2 2 1 8 5 0 4 -8 1 -5 0 -71 -1 -2 -3 0 -2 2 -2 0 -3 -3 0 -3 11 -11 0 -37 -1 -1 -7 1 -3 -3 0 -3 11 -11 0 -36 -1 -2 -7 1 -3 -5 11 -11 0 -37 -8 0 -2 -2 0 -4 3 -4 7 -5 0 -5 1 -1 0 -25 -1 -4 -5 0 -1 1 -4 -5 1 -3 8 -6 2 -3 0 -28 -1 -2 -4 0 -5 -4 1 -3 7 -5 0 -4 -7 -23 -2 -15 1 -1 0 -5 4 -9 7 -7 6 -3 9 -2 18 1 10 4 7 6 5 11 -1 17 -8 25 0 6 6 6 -4 5 -5 0 0 27 -1 1 0 3 10 9 0 4 -4 3 -5 -1 0 30 -1 5 11 10 -2 4 -8 1 0 32 -1 5 11 11 -1 3 -3 2 -6 -1 0 34 -1 5 11 11 -3 5 -7 -1 0 23 -1 1 -1 14 12 12 -4 5 -6 -1 0 27 -1 1 0 22 -1 1 1 28 5 7 3 0 1 -8 2 -2 4 -1 4 4 1 3 0 10 26 0 1 -1 21 -1 6 -2 10 -1 7 -3 6 -1 11 -7 2 0 -1 -1 1 -24 -14 2 -6 9 -7 6 -8 -7 -4 -6 -11 -2 -4 -2 -2 -3 8 -14 2 -8 6 -78 -8 1 -13 6 -8 6 -4 0 -4 -5 -1 -9 -10 -11 1 -4 9 -9 1 -8 4 -6 4 0 23 12 5 0 0 -5 -2 -6 -6 -10 -6 -7 0 -4 6 -4 9 -2 10 -12 5 0 9 12 13 3 5 5 -13 17 -3 7 0 6 5 0 14 -6 0 -20 -1 -1 1 -2 0 -20 -1 -1 1 -44 1 -1 0 -8 1 -1 1 -15 2 -8 2 -26 2 -8 0 -12 1 -1 0 -3 -3 -4 0 -14 1 -1 1 -54 1 -1 0 -47 1 -1 0 -21 -1 -1 1 -1 0 -65 -1 -1 1 -13 -3 -9 0 -6 -2 -3 -1 -6 -3 -7 -4 -6z',
      outer_thumb: 'M71 133l-11 1 -2 3 -8 4 -14 14 -8 12 -8 17 -5 13 0 3 -2 3 -5 23 -1 21 -1 1 0 20 1 1 1 23 3 12 0 5 4 12 0 4 16 45 25 53 2 -2 1 -5 -2 -5 -1 -9 -2 -4 0 -5 -2 -3 1 -4 -2 -2 0 -5 -2 -6 0 -6 -1 -1 1 -4 -2 -2 1 -5 -3 -14 1 -1 -1 -5 1 -2 -1 -4 1 -3 -1 -4 1 -3 -1 -4 1 -3 -1 -4 1 -2 -1 -4 1 -6 -1 -1 2 -2 -1 -4 2 -2 0 -6 1 -1 -1 -4 2 -3 1 -10 2 -3 1 -10 2 -2 2 -11 2 -2 0 -4 3 -4 1 -6 12 -28 0 -3 5 -9 0 -3 4 -8 3 -12 4 -7 -1 -7 -6 -7zM447 105l-2 3 -11 7 -10 11 -12 22 0 3 -4 10 -4 20 0 12 -1 1 1 45 1 1 4 28 7 28 7 20 0 3 2 3 6 20 3 6 0 3 20 50 2 2 0 2 9 18 6 9 1 4 1 0 2 -4 0 -4 -4 -21 0 -8 -3 -15 -1 -20 -1 -1 0 -7 -2 -9 -1 -24 -1 -1 -1 -20 -1 -1 0 -21 -1 -1 1 -36 1 -1 0 -7 2 -4 0 -7 1 -1 0 -6 2 -3 0 -4 -10 -10 -3 -10 -1 -15 -1 -1 1 -1 1 -17 3 -4 0 -5 -1 -1 0 -5 -2 -2 0 -10 -2 -3 0 -13 -2 -2 0 -4z',
      inner_thumb: 'M93 150l-4 1 -5 17 -4 8 0 3 -5 9 0 3 -12 28 -1 6 -3 4 0 4 -2 2 -2 11 -2 2 0 5 -2 3 -1 9 -2 3 -1 12 -1 1 1 4 -2 2 0 5 -1 1 1 5 -1 1 0 38 1 1 -1 5 2 8 -1 4 2 2 -1 5 2 7 0 6 2 6 1 11 2 3 0 5 2 4 2 10 0 5 -2 3 6 11 2 7 5 10 3 -3 6 -15 0 -3 2 -3 5 -16 3 -14 2 -3 0 -4 7 -25 0 -5 3 -11 2 -22 1 -1 0 -13 1 -1 -1 -32 -3 -13 0 -10 -4 -7 -3 -14 0 -7 -1 -1 1 -19 2 -10 0 -21 2 -8 0 -12z',
      wrist: 'M477 663l2 5 0 42 5 5 17 5 16 3 35 2 1 1 82 1 1 -1 26 0 1 -1 14 0 1 -1 18 -1 19 -4 11 -5 -1 -3 1 -1 0 -20 1 -1 0 -30 -19 -8 -11 -1 -1 1 0 6 4 14 3 6 8 9 0 2 -2 3 -4 2 -4 0 -5 2 -5 9 -2 2 -4 1 -10 -12 -11 -2 -4 -4 9 -15 4 -16 0 -7 -9 1 -11 5 -10 7 -4 0 -3 -4 -2 -9 -9 -9 0 -8 -8 -3 -6 0 2 28 1 1 2 18 4 10 6 7 0 4 -5 4 -10 1 -12 12 -11 -11 -11 -2 -5 -4 1 -4 7 -10 3 -11 4 -35 1 -1 0 -6 -1 -1 -8 1 -5 3 0 8 -8 7 -1 8 -4 7 -3 0 -19 -10 -12 -2 0 9 4 13 9 12 1 4 -4 4 -9 2 -10 13 -3 0 -10 -12 -10 -2 -5 -4 0 -2 6 -7 5 -11 2 -9 0 -8 -7 0zM476 595l0 5 1 1 0 17 -1 3 15 7 11 2 0 -8 -2 -5 -11 -15 0 -2 8 -6 0 -5 -7 0 -11 6zM522 587l0 4 2 3 10 1 4 3 0 4 -9 12 -3 8 0 6 8 0 6 -3 -1 -6 9 -8 3 -10 0 -5 -18 -8zM728 592l-15 -7 -10 -1 0 8 2 0 4 5 -11 15 -2 5 0 8 9 -1 17 -10 6 -2zM668 583l-21 10 0 4 3 8 0 5 2 0 4 3 2 3 0 6 3 3 11 1 0 -5 -2 -6 -4 -7 -7 -8 0 -4 2 -2 14 -5 0 -6zM476 539l0 19 7 3 9 1 0 -6 -5 -9 -6 -7zM728 474l-2 -1 -18 5 -23 2 -7 2 -11 0 -1 1 -18 0 -1 1 -99 0 -1 -1 -18 0 -1 -1 -10 0 -8 -2 -14 -1 -17 -5 0 4 -3 9 0 8 -1 1 2 32 13 -4 2 -2 2 -6 6 -6 4 1 9 10 13 2 4 5 -11 19 -1 11 6 0 10 -6 9 -8 4 -2 3 1 4 6 1 6 11 11 -2 6 -6 7 -1 15 15 8 11 4 6 0 0 -5 -2 -4 0 -3 -6 -11 -8 -10 5 -5 11 -2 8 -10 2 -1 4 1 7 10 8 1 7 4 -1 5 -7 9 -5 11 -1 8 1 1 6 0 10 -4 14 -8 0 -8 -2 -8 -6 -6 -3 -6 11 -11 2 -9 4 -5 2 -1 4 2 9 7 11 6 6 0 0 -5 -3 -8 -11 -18 5 -5 13 -2 5 -7 6 -5 3 1 3 3 6 10 10 3 5 4 -1 6 -11 13 -4 8 0 5 9 -1 11 -5 3 0 0 -41 1 -1 0 -25 -1 -1zM101 257l-3 0 0 11 3 13 0 15 1 1 -1 26 -3 15 0 8 -3 11 0 5 -3 9 0 4 -2 4 -2 12 -2 3 -5 21 -10 28 -4 5 4 9 5 18 4 -3 3 -5 0 -2 4 -6 8 -18 2 -2 3 -9 2 -2 0 -4 5 -9 0 -3 6 -14 2 -11 3 -7 0 -6 3 -8 1 -14 2 -8 0 -26 -1 -1 1 -5 -1 -1 0 -6 -2 -2 0 -5 -2 -3 -1 -10 -7 -15 -2 -2 0 -2 -5 -7z',
      trim: 'M344 712l-1 -2 -14 8 -6 1 -7 3 -10 1 -6 2 -21 1 -1 1 -5 -1 -3 1 -16 0 -1 13 35 -1 1 -1 6 0 31 -6 11 -4 5 -4 2 -4zM78 712l0 8 2 4 8 5 9 3 9 1 4 2 21 2 8 2 27 0 2 1 1 -3 -1 -10 -1 -1 -15 1 -1 -1 -17 0 -1 -1 -14 -1 -23 -6 -8 -4 -6 -5 -3 0zM477 714l0 6 2 4 10 5 31 6 27 1 1 1 20 0 1 1 76 0 1 -1 35 -1 1 -1 9 0 1 -1 12 -1 14 -3 5 -2 4 -5 -1 -11 -13 6 -19 4 -18 1 -1 1 -14 0 -1 1 -26 0 -1 1 -50 0 -1 -1 -27 0 -1 -1 -35 -2 -16 -3 -17 -5 -7 -6 0 3zM222 628l0 19 -1 1 1 3 0 11 -1 1 0 10 1 1 -1 1 0 36 1 3 -1 2 3 3 0 2 4 7 6 6 7 3 2 -4 0 -8 -1 -3 -5 -5 -2 -4 0 -6 -1 -1 1 -40 1 -1 0 -30 -9 -7zM201 627l-4 0 -9 7 1 5 0 67 -1 5 -4 8 -5 3 0 10 2 5 11 -7 5 -7 2 -6 3 -2 -1 -1 0 -6 1 -1 0 -77zM222 575l0 19 -1 1 1 12 -1 4 9 8 4 0 1 -1 0 -10 1 -1 0 -26 -8 -6zM202 573l-4 0 -10 7 1 5 0 34 5 -1 8 -7zM222 521l0 19 -1 1 1 3 0 14 8 7 5 1 1 -2 0 -37 -8 -6zM202 519l-4 0 -10 8 1 5 0 33 5 -1 8 -6zM222 468l0 37 8 6 5 1 1 -2 0 -35 -2 -3 -5 -3zM202 467l-6 1 -7 6 0 37 6 -1 7 -6zM222 419l0 33 10 8 3 0 1 -2 0 -32 -9 -7zM202 418l-4 0 -9 7 0 6 1 1 -1 27 4 0 9 -7zM223 380l-1 23 10 8 3 0 1 -2 0 -29zM202 380l-13 0 1 4 0 26 3 0 7 -5 3 -4 -1 -3zM190 303l-8 9 -3 12 0 8 1 1 1 10 7 25 1 1 10 0 2 -1 0 -5 -9 -33 0 -5 2 -5 6 -6 4 -2 13 -1 12 4 6 8 -1 12 -6 16 -1 7 -2 4 0 6 8 2 6 -1 1 -8 3 -7 5 -19 0 -16 -5 -11 -3 -3 -9 -5 -10 -2 -16 0 -1 1 -5 0z',
      laces: 'M251 710l-8 1 -3 10 2 10 -3 5 2 2 0 5 -1 1 0 9 -1 1 -2 27 -1 1 0 7 2 2 7 0 2 -1 1 -3 3 -34 1 -1 0 -10 3 -2 -1 -2 1 -22 -1 -3zM171 710l-4 5 -1 13 2 7 -2 4 3 3 3 42 3 7 8 0 2 -2 0 -7 -1 -1 0 -11 -1 -1 0 -7 -1 -1 0 -7 -2 -9 0 -7 3 -2 -2 -2 -1 -4 0 -6 2 -2 -1 -9 -2 -3zM207 310l-9 3 -5 5 -2 5 0 9 2 10 3 7 4 17 -3 2 -10 -1 -4 2 -3 4 0 5 4 3 16 0 1 1 0 19 -18 13 -3 3 -1 7 3 4 8 -1 10 -8 1 1 0 30 -7 6 -5 2 -3 4 -6 4 -2 4 0 5 4 3 8 -1 8 -8 2 -1 1 1 0 33 -8 7 -4 1 -11 12 1 7 5 2 5 -2 11 -9 1 1 0 35 -6 5 -6 3 -10 9 -1 9 2 2 6 0 3 -1 2 -3 9 -6 1 1 0 34 -6 6 -6 3 -10 9 -1 9 2 2 6 0 13 -10 2 4 0 73 -1 1 0 10 6 -1 1 1 14 0 1 1 1 -1 0 -6 -1 -1 1 -79 2 -1 10 8 3 1 5 0 3 -4 -1 -6 -22 -18 0 -33 3 -1 7 6 6 3 5 -1 2 -4 -1 -6 -10 -9 -6 -3 -6 -6 0 -33 3 -1 9 7 3 1 5 0 2 -1 1 -7 -3 -4 -20 -15 0 -33 2 -1 7 4 3 4 7 1 4 -4 0 -5 -8 -8 -10 -6 -5 -5 0 -29 2 -1 9 7 4 1 6 -1 2 -4 -1 -5 -4 -4 -13 -8 -5 -5 0 -5 1 -1 -1 -8 2 -6 17 0 3 -4 0 -4 -5 -5 -5 1 -1 -1 -6 0 -2 -2 10 -35 0 -10 -2 -4 -3 -3 -7 -3zM455 150l-3 4 -1 17 -1 1 2 20 5 13 5 5 4 1 3 -3 2 -7 -1 -16 -7 -22 -3 -4 0 -3 -3 -6z',
      cross_1: 'M107 506l-4 3 -8 11 -8 1 -4 2 -3 4 0 3 2 4 11 14 2 8 -2 1 -16 -7 -2 1 0 28 1 1 0 12 19 -7 2 1 -1 21 -1 1 -4 47 -4 14 -4 6 -4 3 0 7 8 4 8 1 3 3 3 6 5 5 7 0 12 -14 10 -1 4 -3 0 -7 -5 -6 -3 -6 -2 -8 -6 -72 4 -1 10 4 4 3 2 0 7 5 7 0 3 -5 1 -8 10 -11 0 -6 -3 -5 -6 -5 -3 -11 -4 -4 -5 0 -14 9 -8 4 -3 0 -1 -1 2 -6 11 -16 2 -7 -5 -5 -10 -2 -10 -12z',
      cross_2: 'M314 505l-6 5 -6 8 -9 2 -4 2 -2 3 1 6 10 13 4 11 -2 1 -7 -3 -16 -9 -8 0 -3 5 -1 8 -10 11 0 6 10 11 1 9 3 4 8 0 14 -9 11 -4 1 1 -6 74 -2 8 -8 13 0 5 1 2 4 2 11 2 10 12 7 1 12 -15 12 -2 1 -4 -1 -9 -5 -6 -4 -15 -6 -68 3 -1 16 4 1 -3 0 -37 -10 5 -6 2 -2 -1 3 -9 9 -13 5 -4 0 -3 -5 -5 -13 -3 -9 -12z',
      cross_3: 'M477 527l-1 2 0 11 3 1 7 8 5 9 0 2 -2 1 -10 -4 -3 0 0 8 -1 1 0 26 1 5 5 -1 11 -6 3 0 1 4 6 0 11 -12 3 1 4 5 11 1 18 8 3 0 2 -2 4 -1 1 -13 8 -11 0 -6 -11 -11 -1 -6 -3 -5 -7 -1 -19 14 -4 2 -3 -1 1 -7 11 -19 0 -5 -3 -3 -11 -1 -11 -11 -8 -1 -5 5 -2 6 -3 3z',
      cross_4: 'M511 581l-9 11 -7 1 -8 6 1 5 11 15 2 5 0 4 -1 1 -4 -1 -15 -7 -5 -1 1 43 1 1 5 -1 4 -3 11 -4 4 1 -2 13 -5 11 -6 7 0 6 4 3 10 2 11 13 3 0 5 -3 3 -6 5 -5 9 -2 3 -3 0 -6 -10 -14 -4 -13 0 -5 1 -1 8 2 19 10 7 0 3 -6 1 -8 8 -7 0 -10 -4 -2 -5 -5 -3 -10 -4 -4 -6 1 -11 8 -3 0 -4 3 -7 1 -1 -3 3 -8 9 -12 1 -6 -4 -4 -10 -1 -2 -2 -1 -4 -5 -5z',
      cross_5: 'M597 554l-5 4 -5 7 -11 2 -4 4 0 4 11 15 3 6 2 8 -1 1 -6 -1 -2 -2 -5 -1 -14 -8 -6 0 -4 3 -3 13 -9 8 0 7 6 0 11 -8 4 0 3 4 3 10 7 6 5 0 2 -2 6 -2 2 2 -4 32 -3 14 -3 7 -5 6 -2 6 5 5 11 2 10 11 5 0 12 -12 10 -1 5 -5 -1 -6 -6 -7 -5 -14 -4 -39 3 -1 9 4 4 -1 5 -4 2 -11 5 -5 15 7 4 0 1 -4 -3 -7 -6 -3 0 -5 -2 -7 -4 -4 -5 0 -2 2 -22 10 -3 -1 1 -8 4 -8 8 -11 0 -7 -6 -3 -8 -1 -7 -10z',
      cross_6: 'M723 523l-4 -3 -10 -3 -3 -3 -4 -8 -4 -3 -7 1 -6 8 -5 4 -11 1 -4 4 0 5 8 11 6 15 -3 1 -6 -3 -9 -7 -9 -5 -4 0 -4 3 -3 11 -11 11 1 7 8 9 2 8 0 6 7 2 19 -10 9 -1 7 -5 2 0 6 6 2 4 3 2 8 0 0 -5 3 -1 7 2 14 7 1 -44 -5 0 -5 3 -3 0 -7 3 -2 -1 6 -12 9 -10 2 -5z',
      cross_7: 'M681 578l-7 5 0 4 -2 2 -9 2 -4 2 -2 3 1 6 9 11 4 11 -1 1 -7 -1 -3 -3 -8 -2 -6 -4 -8 -1 -4 4 -2 11 -8 6 0 9 9 9 2 9 4 4 6 -1 10 -7 11 -5 5 -1 1 4 -2 5 -1 8 -4 9 -6 8 0 5 3 3 11 2 10 12 6 0 3 -2 6 -10 5 -2 4 0 4 -2 1 -2 0 -6 -8 -9 -3 -6 -4 -16 2 -2 7 1 3 2 6 1 9 5 3 0 1 -3 0 -46 -4 0 -11 7 -10 5 -5 1 -1 -5 2 -5 10 -13 1 -7 -3 -3 -11 -2 -9 -11z'
    }
  };
  // Japanese Flat Wrist base: Tony's drawing traced into colour areas (SVG paths, crop coordinates) plus a line layer
  // (theme asset fsb-flat-lines.js, a PNG kept as a data URL, same folder as this script). strip = the binding beside
  // the inner thumb, coloured with Glove Top like on the ribbed-wrist glove. fsb = FiveStar wrist logo [centre x, centre y, width].
  var SCRIPT_SRC = (document.currentScript && document.currentScript.src) || '';
  var FLAT = {
    url: SCRIPT_SRC ? SCRIPT_SRC.replace(/fsb-set\.js(\?.*)?$/, 'fsb-flat-lines.js?v=1') : '',
    tw: 864, th: 783, logo: [674, 207, 207, 149], name: [674, 406, 274, 48], fsb: [670, 606, 136],
    zones: {
      glove_top: 'M526 34l-8 6 -10 10 -10 16 -5 15 -1 25 -2 2 0 2 1 1 3 21 7 24 0 4 3 1 5 21 7 13 7 19 -2 13 -2 1 0 6 -1 1 0 6 -1 1 -3 27 -1 1 0 9 -1 1 0 9 -1 1 0 14 -1 1 0 38 1 1 0 14 1 1 0 9 1 1 0 9 1 1 2 20 12 63 -1 6 2 3 -1 27 2 -1 1 1 35 3 1 1 10 0 1 1 13 0 1 1 13 0 1 1 23 0 1 1 91 0 1 -1 19 0 1 -1 10 0 1 -1 10 0 1 -1 13 -1 43 -10 7 -91 1 -1 4 -35 2 -7 0 -6 3 -13 0 -6 4 -19 0 -6 2 -7 3 -28 2 -8 3 -33 1 -1 0 -9 1 -1 0 -11 1 -1 0 -24 3 -7 -1 -15 2 -3 -1 -6 -2 -2 0 -4 2 -4 0 -10 -3 -8 0 -9 1 -1 1 -11 -6 -25 -7 -15 -9 -10 -7 -5 -16 -8 -20 -7 -35 -9 -25 -5 -6 0 -1 -1 -20 -2 -8 -2 -7 0 -1 -1 -7 0 -1 -1 -18 -1 -1 -1 -24 -1 -1 -1 -27 0 -1 1 -16 1 -23 5 -16 5zM47 97l4 0 15 -8 16 -4 24 -1 3 3 3 0 6 -3 6 6 2 18 3 8 2 1 12 15 14 13 1 3 3 3 9 4 7 7 5 3 10 1 2 4 5 4 11 3 15 -1 7 7 10 3 25 0 1 -1 5 0 8 -4 4 0 8 3 7 0 9 -9 5 3 7 0 14 -4 8 -4 8 -6 31 -31 4 3 3 8 1 10 1 1 -1 4 2 3 1 16 2 3 3 -5 0 -4 -3 -8 0 -3 3 -5 0 -12 1 -1 0 -8 -2 -10 1 -31 1 -1 0 -29 -3 -15 -3 -5 -6 -6 -13 -7 -24 -8 -24 -6 -26 -4 -1 -1 -13 -1 -1 -1 -29 -2 -1 -1 -15 0 -1 -1 -64 -1 -1 1 -15 0 -20 4 -18 8 -26 20 -37 38 -6 8z',
      strip: 'M125 210l-2 0 -2 2 0 11 8 9 0 6 3 7 0 23 -1 1 0 9 -1 1 0 8 -2 10 0 11 2 3 -5 24 0 5 -2 3 -2 15 -2 4 -4 20 -2 3 0 4 -2 3 -2 9 -7 16 -3 3 -4 8 -15 15 0 3 5 9 4 12 2 0 4 -4 7 -10 0 -2 3 -3 0 -2 6 -6 4 -10 2 -1 4 -7 0 -2 3 -3 0 -3 2 -2 1 -4 2 -2 0 -3 6 -15 1 -9 2 -2 1 -11 2 -3 4 -19 4 -10 -1 -3 3 -9 3 -24 2 -7 -1 -3 2 -9 -1 -3 1 -1 0 -12 -1 -1 1 -3 -5 -20 -7 -12 -12 -12z',
      palm: 'M128 115l-2 6 -1 14 -1 1 0 8 1 4 3 4 0 6 -1 1 0 9 -1 1 -2 21 -2 7 0 13 9 6 13 13 7 12 0 3 2 3 0 4 2 4 1 18 -1 1 -1 21 -1 1 -3 24 -2 4 -1 10 -6 19 -1 8 -2 3 -1 11 -2 2 -3 16 -2 2 -2 9 -5 8 0 3 -3 3 0 2 -4 7 -2 1 -4 10 -6 6 0 2 -3 3 0 2 -3 3 -1 3 -8 9 1 6 -3 3 -4 11 -1 77 1 1 0 9 1 1 1 12 6 28 2 24 1 1 0 12 1 1 -1 41 2 10 5 2 17 2 1 1 22 1 8 2 11 0 7 2 11 0 1 1 5 -1 2 1 4 -1 5 1 1 -1 7 0 2 -2 0 -10 2 -4 5 -3 2 0 2 2 0 5 -1 1 1 8 2 0 6 -4 3 -7 0 -9 -1 -1 1 -3 -5 -26 -2 -19 -1 -1 -6 0 -10 3 -4 -3 -1 -3 3 -4 14 -4 3 -2 -1 -16 -1 -1 0 -18 -1 -1 1 -5 -1 -2 -13 1 -4 -5 3 -4 11 -3 3 -2 0 -22 -1 -1 1 -1 -1 -5 1 -1 -1 -5 1 -5 -1 -1 0 -5 -5 0 -7 3 -6 0 -3 -3 0 -3 4 -5 5 -3 10 -2 2 -2 -1 -5 1 -1 -1 -5 1 -5 -1 -1 0 -24 -1 -2 -3 0 -11 4 -5 -5 2 -5 4 -4 13 -4 -1 -49 -1 -1 -9 1 -3 -4 1 -3 4 -4 9 -5 0 -2 -1 -1 0 -14 -1 -1 1 -5 -1 -1 -1 -16 -2 -4 -5 0 -7 2 -5 -5 0 -4 3 -3 8 -2 0 -3 -10 -19 -2 -8 0 -13 4 -10 8 -8 4 -1 2 -2 5 0 1 -1 16 3 17 8 15 11 6 6 9 14 4 14 1 9 -4 19 3 3 8 4 5 6 0 3 -4 3 -13 -2 0 5 1 1 0 29 12 7 6 6 1 6 -2 2 -3 0 -11 -7 -3 1 0 10 1 1 -1 1 1 5 -1 1 1 5 -1 1 1 5 -1 1 0 15 12 9 4 4 2 5 -4 5 -4 0 -6 -4 -3 0 -1 2 0 18 -1 1 0 13 -1 3 18 17 2 4 -3 4 -3 1 -7 -3 -3 -3 -4 1 0 17 -1 1 -1 19 9 6 8 8 0 2 -5 4 -8 -6 -4 0 -1 16 -1 1 0 17 -2 3 0 2 13 10 7 7 1 4 -4 4 -3 -1 -9 -7 -5 -1 -1 15 -2 9 0 10 -1 1 -1 23 -1 1 1 16 3 2 5 0 2 -10 5 -4 2 0 3 4 0 12 10 1 1 1 3 -1 7 0 1 1 14 -1 4 -2 10 -1 7 -3 5 0 7 -3 4 0 3 -2 9 -1 3 -2 7 -1 3 -2 -1 -1 0 -8 1 -1 0 -39 1 -1 0 -31 1 -1 0 -31 1 -1 0 -31 1 -1 0 -46 1 -1 -4 -110 1 -1 1 -27 7 -30 0 -16 -1 -1 1 -36 1 -1 2 -47 1 -1 0 -9 1 -1 0 -22 -1 -1 0 -21 -1 -1 0 -10 1 -2 -2 -3 -2 -23 -4 -17 -4 -5 -3 0 -32 32 -8 6 -8 4 -14 4 -3 0 -5 -3 -4 0 -9 9 -11 -3 -8 0 -8 4 -5 0 -1 1 -21 0 -10 -3 -9 -8 -7 2 -6 0 -13 -4 -4 -4 -1 -3 -12 -2 -10 -9 -9 -4 -4 -4 -1 -3 -22 -22 -4 -6z',
      outer_thumb: 'M491 107l-9 9 -11 17 -5 11 -5 16 -3 15 -1 14 -1 1 0 11 -1 1 1 37 1 1 1 15 5 25 11 34 0 3 19 55 12 48 4 10 14 23 4 15 1 0 1 -8 -12 -63 0 -6 -3 -15 -1 -19 -1 -1 0 -14 -1 -1 1 -49 1 -1 2 -27 1 -1 1 -13 3 -14 0 -8 -3 -1 -9 -9 -4 -8 -4 -13 -1 -12 -1 -1 0 -10 2 -10 3 -5 -8 -29zM120 83l-5 0 -3 2 -2 0 -2 -2 -28 1 -16 4 -15 8 -2 0 -19 19 -7 11 -9 20 -5 20 0 9 -1 1 0 62 1 1 0 11 1 1 1 14 4 18 16 43 20 42 13 37 18 39 0 2 3 -3 -1 -4 0 -19 1 -1 1 -20 1 -1 7 -71 1 -1 0 -7 1 -1 0 -7 1 -1 0 -7 1 -1 0 -7 2 -8 0 -7 2 -8 0 -7 2 -8 4 -35 5 -26 9 -25 6 -22 0 -6 -1 -1 1 -13 2 -10 2 -3 0 -3 -3 -7 -2 -18z',
      inner_thumb: 'M127 147l-3 1 -5 21 -9 25 -5 26 -4 35 -2 8 0 7 -2 8 0 7 -2 8 -3 31 -1 1 0 8 -1 1 0 8 -1 1 0 8 -1 1 0 8 -1 1 -1 17 -1 1 0 8 -2 10 -1 20 -1 1 0 23 1 1 4 -1 10 -11 4 -8 3 -3 7 -16 0 -3 4 -9 0 -4 2 -3 4 -20 2 -4 2 -15 2 -3 0 -5 5 -24 0 -5 -2 -2 0 -7 1 -1 2 -27 1 -1 0 -27 -3 -7 0 -6 -8 -9 0 -7 2 -2 -1 -13 2 -7 2 -21 1 -1 0 -9 1 -1 0 -10z',
      wrist: 'M820 490l-4 0 -16 5 -25 5 -6 0 -8 2 -10 0 -1 1 -10 0 -1 1 -19 0 -1 1 -111 -1 -1 -1 -27 -1 -1 -1 -10 0 -1 -1 -9 0 -1 -1 -30 -3 0 2 -5 9 -1 14 6 8 1 14 -7 17 -1 22 5 24 1 21 1 1 0 62 1 1 0 16 2 10 40 1 1 1 6 -1 1 1 38 1 1 1 57 0 1 -1 27 0 1 -1 26 0 1 -1 57 0 1 1 21 1 2 -51 1 -1 0 -22 1 -1 2 -66 1 -1 0 -14 1 -1 1 -26 1 -1z',
      laces: 'M647 731l-1 1 2 4 2 16 1 1 2 22 10 0 -3 -28 -3 -13 1 -2 -1 -1zM692 730l-1 1 2 2 0 5 -1 1 1 36 2 1 9 0 0 -44 2 -2zM283 708l-8 1 -3 5 -1 15 -1 1 1 5 -1 1 -4 31 -2 6 1 3 10 -1 7 -39 2 -2 0 -7 1 -1 0 -15zM210 693l-4 2 -2 4 0 10 -1 1 2 10 -1 3 2 1 8 51 1 1 9 0 -1 -10 -1 -1 0 -8 -1 -1 -1 -19 -2 -9 0 -7 1 -1 -2 -3 0 -10 -1 -1 2 -11 -2 -2zM208 282l-6 5 -1 14 3 9 11 18 0 2 -1 1 -9 0 -1 1 -1 -1 -5 0 -4 2 -3 0 -2 2 0 8 4 4 5 0 19 -4 5 2 1 22 4 6 0 2 -5 7 -8 4 -5 1 -8 5 -3 3 -1 7 2 3 5 1 4 -2 3 0 11 -6 2 1 1 3 0 23 1 1 -1 1 0 11 1 1 0 7 -3 3 -9 3 -3 -1 -3 2 -7 1 -4 2 -5 7 0 5 4 4 6 0 21 -10 3 2 1 41 -2 2 -6 2 -7 0 -2 2 -4 0 -8 3 -6 6 0 7 2 2 10 0 7 -3 3 0 9 -5 4 1 1 34 3 4 0 3 -3 4 -4 2 -11 1 -3 2 -11 3 -2 2 0 5 3 4 15 -1 2 -2 10 -3 2 2 0 18 1 1 -1 5 1 1 0 7 3 5 -4 5 -6 2 -7 0 -3 2 -14 4 -2 3 0 4 2 4 7 1 9 -3 5 0 2 -2 9 -2 4 20 0 15 2 2 -1 1 0 9 2 4 0 7 16 0 0 -10 1 -1 0 -14 -1 -1 1 -2 -1 -3 1 -27 2 -1 12 11 3 1 9 7 7 1 4 -4 0 -3 -2 -4 -6 -6 -27 -19 0 -10 1 -1 1 -21 2 -6 10 7 2 3 2 0 8 6 4 0 4 -3 0 -6 -7 -7 -13 -8 -11 -9 2 -9 -1 -5 1 -1 1 -22 2 -1 11 13 8 5 7 1 3 -1 2 -3 0 -4 -2 -4 -17 -16 -14 -11 2 -10 -1 -6 1 -1 0 -19 1 -1 12 13 7 4 6 1 5 -5 0 -6 -2 -3 -17 -13 -13 -13 1 -5 -1 -32 2 -2 13 10 13 7 4 -1 2 -3 -2 -8 -8 -7 -7 -3 -3 -3 -2 0 -8 -8 -4 -6 -2 -5 2 -5 0 -12 -1 -1 2 -2 12 7 7 2 9 -1 2 -5 -2 -5 -3 -3 -8 -4 -3 -3 -3 0 -11 -6 1 -5 5 -10 0 -4 -12 -21 -11 -12 -25 -9zM258 564l1 -1 1 1 -1 1z',
      trim: 'M527 721l1 7 5 2 112 1 2 3 2 -2 8 1 2 -2 29 0 2 -1 3 2 1 -1 11 0 8 -2 37 0 1 1 22 0 1 1 27 1 1 -1 6 0 4 -5 -2 -7 -19 -1 -1 -1 -61 0 -1 1 -54 1 -1 1 -53 0 -1 -1 -38 -1 -2 -2 -5 2 -1 -1 -26 0 -1 -1 -13 0 -2 -1zM383 711l-3 -3 -6 3 -16 3 -3 2 -8 1 -3 2 -5 0 -7 3 -5 0 -19 4 -1 -1 -23 -1 -1 1 0 10 1 -1 20 1 1 -1 7 0 21 -4 29 -3 11 -3 6 -3 4 -5zM95 706l1 5 4 3 7 3 10 2 41 1 1 1 10 0 1 1 9 0 1 1 26 0 0 -5 -2 -7 -10 1 -1 1 -1 -1 -10 0 -1 1 -8 -2 -4 1 -7 -2 -11 0 -8 -2 -29 -2 -1 -1 -10 -1 -3 -2 -4 0zM220 638l-2 2 0 2 1 1 2 19 4 19 0 10 1 1 -1 4 1 1 -3 7 -7 5 0 10 2 3 1 -2 9 -3 6 -6 4 -12 14 0 1 1 0 19 2 4 5 5 9 3 2 2 1 -2 0 -9 -5 -1 -2 -2 -1 -4 6 -71 -13 -10 -3 1 0 13 -1 1 1 33 -2 3 1 8 -1 1 -12 0 -1 -1 0 -7 -2 -4 0 -5 2 -2 0 -2 -3 -3 1 -11 -2 -5 -2 -19zM259 581l-2 26 -2 3 1 12 12 8 2 0 2 -3 0 -12 1 -1 -1 -4 2 -9 -1 -3 1 -9 -11 -8zM229 579l-4 0 -11 4 1 5 -1 1 1 23 1 1 1 14 8 0 6 -2 3 -4 0 -4 -3 -5 0 -7 -1 -1 1 -5 -1 -1 0 -18zM262 525l-3 42 10 8 5 1 1 -1 0 -9 1 -1 -1 -5 1 -1 1 -22 -10 -11zM228 520l-7 0 -8 4 0 8 1 1 -1 1 1 5 -1 1 1 5 -1 1 1 5 -1 4 1 1 0 15 1 1 11 -2 4 -2 3 -5 0 -3 -4 -6zM264 469l0 19 -1 1 0 5 1 1 -2 7 0 7 12 10 2 0 2 -3 -1 -4 1 -5 -1 -2 1 -1 1 -24 -11 -11zM226 461l-5 0 -10 5 1 5 -1 2 1 4 0 18 1 1 -1 1 1 5 -1 5 2 4 7 -1 7 -3 0 -25 -1 -1 1 -8 -1 -1 0 -10zM264 408l-1 1 0 10 1 1 -1 15 1 1 0 5 -2 4 0 3 13 14 3 0 1 -2 -1 -3 1 -2 -1 -4 1 -2 -1 -5 1 -1 -1 -5 1 -1 -1 -5 1 -1 -1 -5 1 -10 -11 -8zM225 397l-5 0 -11 6 1 3 0 22 1 1 -1 1 1 5 -1 4 1 1 0 12 1 1 8 -1 7 -4 0 -11 -1 -1 1 -12 -1 -1 0 -23zM263 361l-1 1 1 13 -2 3 1 9 5 8 7 7 4 0 1 -3 -1 -3 1 -11 -1 -1 0 -12 -1 -1 1 -4 -11 -6zM220 342l-13 1 -1 1 3 12 0 10 1 1 -1 1 1 5 -1 5 2 10 5 -1 8 -4 5 -8 0 -2 -5 -8 -1 -22zM192 277l-4 10 0 20 2 2 0 3 3 7 5 7 2 6 6 1 1 -1 9 0 1 -1 -1 -5 -7 -10 -7 -17 1 -10 7 -6 7 0 23 7 6 3 9 9 15 25 -7 15 0 3 11 6 5 -1 0 -4 2 -2 -1 -3 2 -7 -1 -16 -7 -17 -11 -13 -15 -11 -17 -8 -11 -3 -15 1 -2 2 -4 1z'
    }
  };
  var BASES = [['classic', 'Japanese Ribbed Wrist'], ['flat', 'Japanese Flat Wrist'], ['crosses', 'Crosses']];
  var BASE_NAME = {}; BASES.forEach(function (b) { BASE_NAME[b[0]] = b[1]; });
  var SW = [['White', '#ffffff'], ['Black', '#111111'], ['Red', '#c0201a'], ['Wine Red', '#6e1230'], ['Maroon', '#8e1b1b'],
    ['Pink', '#e59ab0'], ['Orange', '#f06a12'], ['Yellow', '#f7e23b'], ['Gold', '#d9b65f'], ['Silver', '#c9ccd1'],
    ['Grey', '#7d7d7d'], ['Navy Blue', '#13213f'], ['Royal Blue', '#2c56c0'], ['Sky Blue', '#5aa0cf'], ['Teal', '#2b9a9a'], ['Purple', '#7b2fbf']];
  // the cross colour panel also offers two greens
  var XSW = []; SW.forEach(function (s) { XSW.push(s); if (s[0] === 'Teal') { XSW.push(['Light Green', '#6fc35a']); XSW.push(['Dark Green', '#1d5a32']); } });
  var NAME_OF = {}; XSW.forEach(function (s) { NAME_OF[s[1]] = s[0]; });
  function cname(hex) { return NAME_OF[hex] || hex; }
  var FONTS = [['Bebas Neue', 'Bebas'], ['Anton', 'Anton'], ['UnifrakturMaguntia', 'Gothic'], ['Pirata One', 'Old English'],
    ['Metal Mania', 'Metal'], ['Black Ops One', 'Stencil'], ['Graduate', 'Varsity'], ['Russo One', 'Russo'], ['Bungee', 'Bungee'],
    ['Racing Sans One', 'Racing'], ['Sedgwick Ave Display', 'Graffiti'], ['Permanent Marker', 'Marker'], ['Rye', 'Western'],
    ['Great Vibes', 'Script'], ['Playball', 'Playball'], ['Bangers', 'Bangers'], ['Creepster', 'Creepster'], ['Pattaya', 'Pattaya'], ['Fredoka', 'Fredoka']];
  var FONT_LABEL = {}; FONTS.forEach(function (f) { FONT_LABEL[f[0]] = f[1]; });
  var LINE = '#262626', LIM = 460;

  var ALL = [
    { key: 'glove', label: 'Gloves', title: 'Select Gloves',
      zones: [['glove_top', 'Glove Top'], ['palm', 'Palm'], ['outer_thumb', 'Outer Thumb'], ['inner_thumb', 'Inner Thumb'], ['wrist', 'Wrist'], ['trim', 'Trim']],
      sizes: MODE === 'glove' ? ['8oz', '10oz', '12oz', '14oz', '16oz'] : ['8oz', '10oz', '12oz', '14oz', '16oz', '18oz'] },
    { key: 'head', label: 'Headgear', title: 'Select Headgear',
      zones: [['left', 'Left Side'], ['right', 'Right Side'], ['left_ear', 'Left Ear Cup'], ['right_ear', 'Right Ear Cup'], ['trim', 'Trim']],
      sizes: ['Small', 'Medium', 'Large', 'XL'] },
    { key: 'groin', label: 'Groin Guard', title: 'Select Groin Guard',
      zones: [['left', 'Left Side'], ['right', 'Right Side'], ['trim', 'Trim']],
      sizes: ['Small', 'Medium', 'Large', 'XL'] }
  ];
  var ITEMS = ALL.filter(function (it) { return MODE === 'set' || it.key === MODE; });
  if (!ITEMS.length) { MODE = 'set'; ITEMS = ALL; }
  var S = {}, UID = 0;
  ITEMS.forEach(function (it) {
    var st = { c: {}, layers: [], size: '' };
    it.zones.forEach(function (z) { st.c[z[0]] = '#ffffff'; });
    S[it.key] = st;
  });
  if (S.glove) {
    S.glove.fsbLogo = true; S.glove.fsbLogoCol = '#111111';
    S.glove.base = 'classic'; S.glove.cc = {};
    CROSSES.crosses.forEach(function (x) { S.glove.cc[x[0]] = x[2]; });
  }
  var META = { notes: '', agree: false };

  /* ---------- layers (names and logos) ---------- */
  function eachLayer(fn) { ITEMS.forEach(function (it) { S[it.key].layers.slice().forEach(fn); }); }
  function live(L) { return L.type === 'name' ? !!L.text : !!L.file; }
  function newLayer(st, type) {
    var used = {}; st.layers.forEach(function (x) { if (x.type === type) used[x.slot] = 1; });
    var slot = 0; while (used[slot]) slot++;
    var L = { id: ++UID, type: type, st: st, slot: slot, off: [0, 0], scale: 1, style: 'Print' };
    if (type === 'name') { L.text = ''; L.col = '#111111'; L.font = 'Bebas Neue'; }
    else { L.file = null; L.img = null; L.cut = null; L.rmbg = true; L.loading = false; }
    st.layers.push(L);
    return L;
  }
  // where a new name/logo starts: extra names stack below/above the first, the 2nd logo goes above the first,
  // later logos cascade slightly from the first so they stay on the item
  function slotOff(L, spec) {
    var k = L.slot;
    if (!k) return [0, 0];
    if (L.type === 'name') return [0, (k % 2 ? 1 : -1) * Math.ceil(k / 2) * spec[3] * 1.35];
    if (k === 1) return [0, -spec[3] * 0.8];
    return [(k - 1) * spec[2] * 0.14, (k - 1) * spec[3] * 0.14];
  }

  /* ---------- layout ---------- */
  var GLOVE = { crop: [58, 104, 962, 870], logo: [808, 430, 230, 190], name: [808, 598, 300, 52] };
  var LAYOUT;
  if (MODE === 'set') {
    LAYOUT = { W: 1200, H: 1000, glove: [28, 44, 0.6], head: ART.head.place, groin: ART.groin.place };
  } else if (MODE === 'glove') {
    var gs = Math.min(940 / GLOVE.crop[2], 940 / GLOVE.crop[3]);
    LAYOUT = { W: 1000, H: 1000, glove: [(1000 - GLOVE.crop[2] * gs) / 2, (1000 - GLOVE.crop[3] * gs) / 2, gs] };
  } else {
    var bx = ART[MODE].box, sc = Math.min(1000 * 0.9 / (bx[2] - bx[0]), 1000 * 0.9 / (bx[3] - bx[1]));
    LAYOUT = { W: 1000, H: 1000 };
    LAYOUT[MODE] = [500 - (bx[0] + bx[2]) / 2 * sc, 500 - (bx[1] + bx[3]) / 2 * sc, sc];
  }

  if (MODE === 'glove') {
    var xs = Math.min(940 / CROSSES.tw, 940 / CROSSES.th);
    LAYOUT.crosses = [(1000 - CROSSES.tw * xs) / 2, (1000 - CROSSES.th * xs) / 2, xs];
    var fs = Math.min(940 / FLAT.tw, 940 / FLAT.th);
    LAYOUT.flat = [(1000 - FLAT.tw * fs) / 2, (1000 - FLAT.th * fs) / 2, fs];
  }
  // the glove drawing in use: crop of the composed glove canvas, where it sits, and where names/logos start
  function gl() {
    if (S.glove && S.glove.base === 'crosses' && LAYOUT.crosses) return { crop: [0, 0, CROSSES.tw, CROSSES.th], g: LAYOUT.crosses, logo: CROSSES.logo, name: CROSSES.name, ok: crossReady, bad: crossFailed };
    if (S.glove && S.glove.base === 'flat' && LAYOUT.flat) return { crop: [0, 0, FLAT.tw, FLAT.th], g: LAYOUT.flat, logo: FLAT.logo, name: FLAT.name, ok: flatReady, bad: flatFailed };
    return { crop: GLOVE.crop, g: LAYOUT.glove, logo: GLOVE.logo, name: GLOVE.name, ok: gloveReady, bad: gloveFailed };
  }

  var P = {};
  function path(d) { if (!P[d]) P[d] = new Path2D(d); return P[d]; }

  /* ---------- canvas ---------- */
  var view = document.getElementById('fsbs-view');
  view.width = LAYOUT.W; view.height = LAYOUT.H;
  var ctx = view.getContext('2d');
  var gc = document.createElement('canvas'); gc.width = 1080; gc.height = 1080; var gx = gc.getContext('2d');
  var tmp = document.createElement('canvas'); var tx = tmp.getContext('2d');
  var IMG = {}, gloveReady = false, gloveFailed = false, gloveKey = '';
  var TILE = { glove_top: [0, 0], palm: [1080, 0], outer_thumb: [2160, 0], inner_thumb: [3240, 0], wrist: [0, 1080], laces: [1080, 1080], trim: [2160, 1080] };

  if (S.glove) (function loadGlove() {
    var left = 3;
    ['atlas', 'det', 'logo'].forEach(function (k) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { if (--left === 0) { gloveReady = true; render(); } };
      im.onerror = function () { gloveFailed = true; render(); };
      im.src = ASSETS[k]; IMG[k] = im;
    });
  })();

  var crossReady = false, crossFailed = false;
  if (MODE === 'glove') (function loadCrosses() {
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () { IMG.crossLines = makeLines(im); crossReady = true; render(); };
    im.onerror = function () { crossFailed = true; render(); };
    im.src = CROSSES.url; IMG.cross = im;
  })();
  var flatReady = false, flatFailed = false;
  if (MODE === 'glove') (function loadFlat() {
    if (!FLAT.url) { flatFailed = true; return; }
    var sc = document.createElement('script'); sc.src = FLAT.url; sc.async = true;
    sc.onload = function () {
      if (!window.FSB_FLAT_LINES) { flatFailed = true; render(); return; }
      var im = new Image();
      im.onload = function () { flatReady = true; render(); };
      im.onerror = function () { flatFailed = true; render(); };
      im.src = window.FSB_FLAT_LINES; IMG.flatLines = im;
    };
    sc.onerror = function () { flatFailed = true; render(); };
    document.head.appendChild(sc);
  })();
  // dark ink with see-through white, "14 oz" removed; null if the browser won't let us read the image
  function makeLines(im) {
    var C = CROSSES, pt = C.patch, cv = document.createElement('canvas'); cv.width = C.tw; cv.height = C.th;
    var x = cv.getContext('2d');
    x.drawImage(im, C.sx, C.sy, C.tw, C.th, 0, 0, C.tw, C.th);
    try {
      var d = x.getImageData(0, 0, C.tw, C.th), p = d.data, i, k, px, py, lum, a;
      for (i = 0; i < p.length; i += 4) {
        lum = (p[i] * 299 + p[i + 1] * 587 + p[i + 2] * 114) / 1000;
        a = (238 - lum) / 150; a = a < 0 ? 0 : a > 1 ? 1 : a;
        k = i / 4; px = k % C.tw; py = (k - px) / C.tw;
        if (px >= pt[0] && px < pt[0] + pt[2] && py >= pt[1] && py < pt[1] + pt[3]) a = 0;
        p[i] = p[i + 1] = p[i + 2] = 22; p[i + 3] = Math.round(a * p[i + 3]);
      }
      x.putImageData(d, 0, 0);
      return cv;
    } catch (e) { return null; }
  }

  function tint(img, sx, sy, sw, sh, colour, dctx, dx, dy, dw, dh) {
    tmp.width = sw; tmp.height = sh;
    tx.globalCompositeOperation = 'source-over'; tx.clearRect(0, 0, sw, sh);
    tx.drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);
    tx.globalCompositeOperation = 'source-in'; tx.fillStyle = colour; tx.fillRect(0, 0, sw, sh);
    tx.globalCompositeOperation = 'source-over';
    dctx.drawImage(tmp, 0, 0, sw, sh, dx, dy, dw, dh);
  }

  // the Crosses glove at its own size (tw x th) on canvas c, with area colours zc and cross colours cc
  function drawCrosses(c, zc, cc) {
    var C = CROSSES, Z = C.zones, pt = C.patch;
    ['glove_top', 'palm', 'outer_thumb', 'inner_thumb', 'wrist'].forEach(function (z) { c.fillStyle = zc[z]; c.fill(path(Z[z]), 'evenodd'); });
    c.fillStyle = '#ffffff'; c.fill(path(Z.laces), 'evenodd');
    c.fillStyle = zc.trim; c.fill(path(Z.trim), 'evenodd');
    C.crosses.forEach(function (x) { c.fillStyle = cc[x[0]]; c.fill(path(Z[x[0]]), 'evenodd'); });
    if (IMG.crossLines) { c.drawImage(IMG.crossLines, 0, 0); return; }
    c.save();
    c.globalCompositeOperation = 'multiply';
    c.drawImage(IMG.cross, C.sx, C.sy, C.tw, C.th, 0, 0, C.tw, C.th);
    c.globalCompositeOperation = 'source-over'; c.fillStyle = zc.palm; c.fillRect(pt[0], pt[1], pt[2], pt[3]);
    c.restore();
  }

  // the Flat Wrist glove at its own size (tw x th) on canvas c; logo = [colour] to draw the FiveStar wrist logo
  function drawFlat(c, zc, logoCol) {
    var Z = FLAT.zones;
    [['glove_top', 'glove_top'], ['strip', 'glove_top'], ['palm', 'palm'], ['outer_thumb', 'outer_thumb'], ['inner_thumb', 'inner_thumb'], ['wrist', 'wrist']].forEach(function (z) {
      c.fillStyle = zc[z[1]]; c.fill(path(Z[z[0]]), 'evenodd');
    });
    c.fillStyle = '#ffffff'; c.fill(path(Z.laces), 'evenodd');
    c.fillStyle = zc.trim; c.fill(path(Z.trim), 'evenodd');
    c.drawImage(IMG.flatLines, 0, 0);
    if (logoCol && IMG.logo && IMG.logo.complete && IMG.logo.naturalWidth) {
      var f = FLAT.fsb, lw = IMG.logo.width, lh = IMG.logo.height, dw = f[2], dh = dw * lh / lw;
      tint(IMG.logo, 0, 0, lw, lh, logoCol, c, f[0] - dw / 2, f[1] - dh / 2, dw, dh);
    }
  }

  function composeGlove() {
    var st = S.glove, key = JSON.stringify([st.base, st.c, st.cc, st.fsbLogo, st.fsbLogoCol, gloveReady, crossReady, flatReady]);
    if (key === gloveKey) return;
    gloveKey = key;
    gx.clearRect(0, 0, 1080, 1080);
    if (st.base === 'crosses') {
      if (!crossReady) return;
      drawCrosses(gx, st.c, st.cc);
      return;
    }
    if (st.base === 'flat') {
      if (!flatReady) return;
      drawFlat(gx, st.c, st.fsbLogo ? st.fsbLogoCol : '');
      return;
    }
    if (!gloveReady) return;
    ['glove_top', 'palm', 'outer_thumb', 'inner_thumb', 'wrist'].forEach(function (z) {
      var t = TILE[z]; tint(IMG.atlas, t[0], t[1], 1080, 1080, st.c[z], gx, 0, 0, 1080, 1080);
    });
    var l = TILE.laces; tint(IMG.atlas, l[0], l[1], 1080, 1080, '#ffffff', gx, 0, 0, 1080, 1080);
    var tr = TILE.trim; tint(IMG.atlas, tr[0], tr[1], 1080, 1080, st.c.trim, gx, 0, 0, 1080, 1080);
    gx.drawImage(IMG.det, 0, 0);
    if (st.fsbLogo) {
      var lw = IMG.logo.width, lh = IMG.logo.height, dw = 150, dh = dw * lh / lw;
      tint(IMG.logo, 0, 0, lw, lh, st.fsbLogoCol, gx, 797 - dw / 2, 832 - dh / 2, dw, dh);
    }
  }

  /* ---------- drawing names and logos (draggable) ---------- */
  var HITS = [], hover = null, drag = null, sel = null, EXPORTING = false;
  function register(c, L, x0, y0, x1, y1) {
    var m = c.getTransform();
    var ax = m.a * x0 + m.c * y0 + m.e, ay = m.b * x0 + m.d * y0 + m.f, bx2 = m.a * x1 + m.c * y1 + m.e, by = m.b * x1 + m.d * y1 + m.f;
    HITS.push({ L: L, box: [Math.min(ax, bx2), Math.min(ay, by), Math.max(ax, bx2), Math.max(ay, by)], k: Math.abs(m.a) || 1 });
  }
  function drawName(c, st, spec) {
    st.layers.forEach(function (L) {
      if (L.type !== 'name' || !L.text) return;
      var so = slotOff(L, spec), x = spec[0] + so[0] + L.off[0], y = spec[1] + so[1] + L.off[1], mw = spec[2] * L.scale, f = spec[3] * L.scale;
      c.save();
      c.textAlign = 'center'; c.textBaseline = 'middle';
      do { c.font = f + "px '" + L.font + "', sans-serif"; if (c.measureText(L.text).width <= mw) break; f -= 2; } while (f > 10);
      var w = c.measureText(L.text).width;
      if (L.col === '#ffffff') { c.lineWidth = 3; c.strokeStyle = '#9a9a9a'; c.strokeText(L.text, x, y); }
      c.fillStyle = L.col; c.fillText(L.text, x, y);
      register(c, L, x - w / 2, y - f * 0.62, x + w / 2, y + f * 0.62);
      c.restore();
    });
  }
  function drawLogo(c, st, spec) {
    st.layers.forEach(function (L) {
      if (L.type !== 'logo' || !L.file) return;
      var so = slotOff(L, spec), x = spec[0] + so[0] + L.off[0], y = spec[1] + so[1] + L.off[1], mw = spec[2] * L.scale, mh = spec[3] * L.scale, w, h;
      var im = L.rmbg && L.cut ? L.cut : L.img;
      if (im) {
        var r = Math.min(mw / im.width, mh / im.height); w = im.width * r; h = im.height * r;
        c.drawImage(im, x - w / 2, y - h / 2, w, h);
      } else { // file type the browser can't show (AI, EPS, PDF...): a box the customer can still place
        w = mw * 0.8; h = mh * 0.7;
        c.save();
        c.fillStyle = 'rgba(255,255,255,0.75)'; c.fillRect(x - w / 2, y - h / 2, w, h);
        c.setLineDash([10, 7]); c.lineWidth = 3; c.strokeStyle = '#8a8a8a'; c.strokeRect(x - w / 2, y - h / 2, w, h);
        c.fillStyle = '#5f5f5f'; c.textAlign = 'center'; c.textBaseline = 'middle';
        var label = L.loading ? 'LOADING...' : 'YOUR LOGO', fs = Math.max(10, Math.round(h * 0.22));
        do { c.font = 'bold ' + fs + 'px sans-serif'; if (c.measureText(label).width <= w * 0.86) break; fs--; } while (fs > 8);
        c.fillText(label, x, y);
        c.restore();
      }
      register(c, L, x - w / 2, y - h / 2, x + w / 2, y + h / 2);
    });
  }
  function outline(L, col) {
    var b = null; HITS.forEach(function (x) { if (x.L === L) b = x.box; });
    if (!b) return;
    ctx.save(); ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.setLineDash([8, 6]); ctx.lineWidth = 2; ctx.strokeStyle = col;
    ctx.strokeRect(b[0] - 6, b[1] - 6, b[2] - b[0] + 12, b[3] - b[1] + 12);
    ctx.restore();
  }
  function drawSelection() {
    if (EXPORTING) return;
    var h = drag ? drag.h.L : (hover ? hover.L : null);
    if (sel) outline(sel, '#2c56c0');
    if (h && h !== sel) outline(h, '#9db1e4');
  }

  var KIT = { path: path, drawName: drawName, drawLogo: drawLogo, LINE: LINE, render: function () { render(); } };

  function render() {
    HITS = [];
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, LAYOUT.W, LAYOUT.H);
    if (S.glove) {
      composeGlove();
      var G = gl(), g = G.g, cr = G.crop, ok = G.ok, bad = G.bad;
      if (ok) ctx.drawImage(gc, cr[0], cr[1], cr[2], cr[3], g[0], g[1], cr[2] * g[2], cr[3] * g[2]);
      else { ctx.fillStyle = '#9a9a9a'; ctx.font = '22px sans-serif'; ctx.textAlign = 'center'; ctx.fillText(bad ? 'Glove preview unavailable' : 'Loading gloves...', g[0] + cr[2] * g[2] / 2, g[1] + cr[3] * g[2] / 2); }
      ctx.save(); ctx.translate(g[0] - cr[0] * g[2], g[1] - cr[1] * g[2]); ctx.scale(g[2], g[2]);
      drawLogo(ctx, S.glove, G.logo); drawName(ctx, S.glove, G.name);
      ctx.restore();
    }
    ['head', 'groin'].forEach(function (key) {
      if (!S[key]) return;
      var p = LAYOUT[key]; ctx.save(); ctx.translate(p[0], p[1]); ctx.scale(p[2], p[2]); ART[key].draw(ctx, S[key], KIT); ctx.restore();
    });
    drawSelection();
    drawThumbs();
  }

  function canvasPt(e) { var r = view.getBoundingClientRect(); return [(e.clientX - r.left) * view.width / r.width, (e.clientY - r.top) * view.height / r.height]; }
  function hitAt(p) {
    for (var i = HITS.length - 1; i >= 0; i--) { var b = HITS[i].box; if (p[0] >= b[0] - 10 && p[0] <= b[2] + 10 && p[1] >= b[1] - 10 && p[1] <= b[3] + 10) return HITS[i]; }
    return null;
  }
  function clamp(v) { return Math.max(-LIM, Math.min(LIM, v)); }
  function dragStart(p) {
    var h = hitAt(p);
    if (!h) { if (sel) select(null); return false; }
    drag = { h: h, p0: p, o0: [h.L.off[0], h.L.off[1]] };
    openCard(h.L, true);
    return true;
  }
  function dragMove(p) {
    if (!drag) {
      var h = hitAt(p); view.style.cursor = h ? 'move' : '';
      var same = (h && hover && h.L === hover.L) || (!h && !hover);
      if (!same) { hover = h; render(); }
      return;
    }
    var o = drag.h.L.off, k = drag.h.k;
    o[0] = clamp(drag.o0[0] + (p[0] - drag.p0[0]) / k); o[1] = clamp(drag.o0[1] + (p[1] - drag.p0[1]) / k);
    render();
  }
  function dragEnd() { if (drag) { drag = null; changed(); } }
  view.addEventListener('mousedown', function (e) { if (dragStart(canvasPt(e))) e.preventDefault(); });
  window.addEventListener('mousemove', function (e) { if (drag || e.target === view || hover) dragMove(canvasPt(e)); });
  window.addEventListener('mouseup', dragEnd);
  view.addEventListener('mouseleave', function () { if (!drag && hover) { hover = null; view.style.cursor = ''; render(); } });
  view.addEventListener('touchstart', function (e) { if (e.touches.length === 1 && dragStart(canvasPt(e.touches[0]))) e.preventDefault(); }, { passive: false });
  view.addEventListener('touchmove', function (e) { if (drag) { e.preventDefault(); dragMove(canvasPt(e.touches[0])); } }, { passive: false });
  view.addEventListener('touchend', dragEnd);
  view.addEventListener('touchcancel', dragEnd);

  /* ---------- fonts ---------- */
  function loadFont(f) {
    if (!document.fonts || !document.fonts.load) return;
    document.fonts.load("40px '" + f + "'").then(function () { render(); }, function () {});
  }
  loadFont('Bebas Neue');
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { render(); });

  /* ---------- uploaded logos: show on the gear, take out a plain background ---------- */
  function canPreview(f) { return /^image\//i.test(f.type || '') || /\.(png|jpe?g|webp|gif|svg|heic|heif|avif)$/i.test(f.name || ''); }
  function trimmed(cv, px, w, h) {
    var x0 = w, y0 = h, x1 = -1, y1 = -1, x, y;
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
      if (px[(y * w + x) * 4 + 3] > 10) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (x1 < 0) return null;
    x0 = Math.max(0, x0 - 2); y0 = Math.max(0, y0 - 2); x1 = Math.min(w - 1, x1 + 2); y1 = Math.min(h - 1, y1 + 2);
    var out = document.createElement('canvas'); out.width = x1 - x0 + 1; out.height = y1 - y0 + 1;
    out.getContext('2d').drawImage(cv, x0, y0, out.width, out.height, 0, 0, out.width, out.height);
    return out;
  }
  // returns { img: logo with empty margins cut off, cut: same logo with its plain background removed (null if it has none) }
  function prepLogo(im) {
    var iw = im.naturalWidth || im.width, ih = im.naturalHeight || im.height;
    if (!iw || !ih) return { img: im, cut: null };
    var s = Math.min(1, 1000 / Math.max(iw, ih)), w = Math.max(1, Math.round(iw * s)), h = Math.max(1, Math.round(ih * s));
    var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
    var cx = cv.getContext('2d'); cx.drawImage(im, 0, 0, w, h);
    var d = cx.getImageData(0, 0, w, h), px = d.data, n = w * h;
    var res = { img: trimmed(cv, px, w, h) || cv, cut: null };
    var edge = [], x, y, i;
    for (x = 0; x < w; x++) { edge.push(x); edge.push((h - 1) * w + x); }
    for (y = 1; y < h - 1; y++) { edge.push(y * w); edge.push(y * w + w - 1); }
    var clear = 0; edge.forEach(function (p) { if (px[p * 4 + 3] < 200) clear++; });
    if (clear > edge.length * 0.1) return res; // already has a transparent background
    var buckets = {}, best = null;
    edge.forEach(function (p) {
      var o = p * 4, k = (px[o] >> 4) + ',' + (px[o + 1] >> 4) + ',' + (px[o + 2] >> 4);
      var b = buckets[k] || (buckets[k] = [0, 0, 0, 0]); b[0]++; b[1] += px[o]; b[2] += px[o + 1]; b[3] += px[o + 2];
      if (!best || b[0] > best[0]) best = b;
    });
    var br = best[1] / best[0], bgc = best[2] / best[0], bb = best[3] / best[0];
    function dist(o) { var r = px[o] - br, g = px[o + 1] - bgc, b = px[o + 2] - bb; return Math.sqrt(r * r + g * g + b * b); }
    var same = 0; edge.forEach(function (p) { if (dist(p * 4) < 40) same++; });
    if (same < edge.length * 0.6) return res; // busy edges (a photo, a full-bleed design): leave it alone
    var T1 = 30, T2 = 75, seen = new Uint8Array(n), stack = new Int32Array(n), sp = 0, gone = 0;
    edge.forEach(function (p) { if (!seen[p] && dist(p * 4) < T2) { seen[p] = 1; stack[sp++] = p; } });
    while (sp) {
      var p = stack[--sp], o = p * 4, dd = dist(o), a = dd <= T1 ? 0 : (dd - T1) / (T2 - T1);
      if (a <= 0) { px[o + 3] = 0; gone++; }
      else { // soften the edge and take the background tint out of it
        px[o] = Math.max(0, Math.min(255, (px[o] - br * (1 - a)) / a));
        px[o + 1] = Math.max(0, Math.min(255, (px[o + 1] - bgc * (1 - a)) / a));
        px[o + 2] = Math.max(0, Math.min(255, (px[o + 2] - bb * (1 - a)) / a));
        px[o + 3] = Math.round(px[o + 3] * a);
      }
      var xx = p % w, yy = (p - xx) / w;
      if (xx > 0 && !seen[p - 1] && dist(o - 4) < T2) { seen[p - 1] = 1; stack[sp++] = p - 1; }
      if (xx < w - 1 && !seen[p + 1] && dist(o + 4) < T2) { seen[p + 1] = 1; stack[sp++] = p + 1; }
      if (yy > 0 && !seen[p - w] && dist(o - w * 4) < T2) { seen[p - w] = 1; stack[sp++] = p - w; }
      if (yy < h - 1 && !seen[p + w] && dist(o + w * 4) < T2) { seen[p + w] = 1; stack[sp++] = p + w; }
    }
    if (gone < n * 0.02 || gone > n * 0.985) return res; // nothing worth removing, or it would erase the whole logo
    var cv2 = document.createElement('canvas'); cv2.width = w; cv2.height = h;
    cv2.getContext('2d').putImageData(d, 0, 0);
    res.cut = trimmed(cv2, px, w, h);
    return res;
  }
  function loadLogo(f, cb) {
    var url = URL.createObjectURL(f), im = new Image();
    im.onload = function () {
      var res;
      try { res = prepLogo(im); } catch (e) { res = { img: im, cut: null }; }
      cb(res);
    };
    im.onerror = function () { try { URL.revokeObjectURL(url); } catch (e) {} cb(null); };
    im.src = url;
  }

  /* ---------- pricing ---------- */
  function embCount() { var n = 0; eachLayer(function (L) { if (live(L) && L.style === 'Embroidered') n++; }); return n; }
  function currentVariant() {
    var n = embCount(), v = null;
    VARIANTS.forEach(function (x) { if (x.n <= n && (!v || x.n > v.n)) v = x; });
    return v || VARIANTS[0];
  }
  function updPrice() {
    var v = currentVariant(); if (!v) return;
    document.getElementById('fsbs-price').textContent = v.price;
    var n = embCount(), note = document.getElementById('fsbs-price-note');
    note.textContent = !n ? '' : FLAT ? 'Includes embroidery' : 'Includes ' + n + ' embroidered item' + (n > 1 ? 's' : '');
  }

  /* ---------- UI ---------- */
  (function addStyles() {
    var css = '.fsbs-bases{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin:8px 0 4px}' +
      '.fsbs-base{all:unset;box-sizing:border-box;cursor:pointer;border:1.5px solid #e0e0e0;border-radius:12px;padding:8px;background:#fff;display:flex;flex-direction:column;align-items:center;gap:6px;font-size:13px;line-height:1.25;text-align:center;font-weight:600;color:#141414;transition:border-color .15s,box-shadow .15s}' +
      '.fsbs-base canvas{width:100%;height:auto;display:block;border-radius:8px}' +
      '.fsbs-base:hover{border-color:#9a9a9a}' +
      '.fsbs-base.on{border-color:#141414;box-shadow:0 0 0 1px #141414}' +
      '.fsbs-base:focus-visible{outline:2px solid #2c56c0;outline-offset:2px}' +
      '.fsbs-xpills{margin:8px 0 6px}.fsbs-xpills .fsbs-pill{display:inline-flex;align-items:center;gap:7px;font-size:13px;padding:7px 12px}' +
      '.fsbs-xdot{width:14px;height:14px;border-radius:50%;border:1px solid #cfcfcf;display:inline-block;flex:0 0 auto;box-sizing:border-box}';
    var tag = document.createElement('style'); tag.textContent = css; document.head.appendChild(tag);
  })();
  var ACC = document.getElementById('fsbs-acc');
  var groups = [], REFRESH = [];
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }

  function changed() {
    render(); updPrice();
    groups.forEach(function (g) { g.sum(); });
    eachLayer(function (L) { if (L.upd) L.upd(); });
    REFRESH.forEach(function (f) { f(); });
  }

  function swatchGrid(parent, label, get, set, list) {
    var box = el('div', 'fsbs-q');
    box.appendChild(el('div', 'fsbs-ql', esc(label) + ' <span class="fsbs-qv"></span>'));
    var grid = el('div', 'fsbs-swg');
    var val = box.querySelector('.fsbs-qv');
    function mark() {
      [].forEach.call(grid.children, function (b) { b.classList.toggle('on', b.getAttribute('data-c') === get()); });
      val.textContent = cname(get());
    }
    (list || SW).forEach(function (s) {
      var b = el('button', 'fsbs-sw', '<span class="dot" style="background:' + s[1] + '"></span><span class="nm">' + s[0] + '</span>');
      b.type = 'button'; b.setAttribute('data-c', s[1]); b.setAttribute('aria-label', label + ', ' + s[0]);
      b.onclick = function () { set(s[1]); mark(); changed(); };
      grid.appendChild(b);
    });
    box.appendChild(grid); parent.appendChild(box); mark();
    return { box: box, mark: mark };
  }

  // opts: [value, label, extra, fontFamily]
  function pills(parent, label, opts, get, set, cls) {
    var box = el('div', 'fsbs-q');
    box.appendChild(el('div', 'fsbs-ql', esc(label)));
    var row = el('div', 'fsbs-pills' + (cls ? ' ' + cls : ''));
    function mark() { [].forEach.call(row.children, function (b) { b.classList.toggle('on', b.getAttribute('data-v') === get()); }); }
    opts.forEach(function (o) {
      var b = el('button', 'fsbs-pill', esc(o[1] || o[0]) + (o[2] ? ' <span class="x">' + esc(o[2]) + '</span>' : ''));
      b.type = 'button'; b.setAttribute('data-v', o[0]);
      if (o[3]) b.style.fontFamily = "'" + o[3] + "', sans-serif";
      b.onclick = function () { set(o[0]); mark(); changed(); };
      row.appendChild(b);
    });
    box.appendChild(row); parent.appendChild(box); mark();
    return box;
  }

  function sizer(parent, L, label, min, max) {
    var row = el('div', 'fsbs-range');
    row.innerHTML = '<span>' + label + '</span><input type="range" min="' + min + '" max="' + max + '" value="100" step="5" aria-label="' + label + '"><button type="button" class="fsbs-reset">Reset position</button>';
    var r = row.querySelector('input');
    r.oninput = function () { L.scale = r.value / 100; if (sel !== L) select(L); else render(); };
    r.onchange = function () { changed(); };
    row.querySelector('button').onclick = function () { L.off = [0, 0]; L.scale = 1; r.value = 100; select(L); changed(); };
    parent.appendChild(row);
  }

  function sub(parent, title) {
    var w = el('div', 'fsbs-sub');
    w.appendChild(el('div', 'fsbs-subh', esc(title)));
    parent.appendChild(w); return w;
  }

  function select(L) {
    sel = L || null;
    eachLayer(function (x) { if (x.card) x.card.classList.toggle('sel', x === sel); });
    render();
  }
  // open one name/logo card (and close the others of the same kind on that item)
  function openCard(L, on) {
    eachLayer(function (x) { if (x.card && x.st === L.st && x.type === L.type) x.card.classList.toggle('open', !!on && x === L); });
    select(on ? L : (sel === L ? null : sel));
  }
  function removeLayer(st, L) {
    var i = st.layers.indexOf(L); if (i < 0) return;
    st.layers.splice(i, 1);
    if (L.card && L.card.parentNode) L.card.parentNode.removeChild(L.card);
    if (sel === L) sel = null;
    if (hover && hover.L === L) hover = null;
    if (drag && drag.h.L === L) drag = null;
    changed();
  }
  function noun(it) { return it.key === 'glove' ? 'gloves' : it.label.toLowerCase(); }

  function layerCard(list, it, st, L, startOpen) {
    var card = el('div', 'fsbs-layer' + (startOpen ? ' open' : '')); L.card = card;
    var head = el('div', 'fsbs-lh');
    var tog = el('button', 'fsbs-lt', (L.type === 'logo' ? '<canvas class="fsbs-lthumb" width="64" height="64" aria-hidden="true"></canvas>' : '') +
      '<span class="ln"></span><span class="ls"></span><span class="chev" aria-hidden="true"></span>');
    tog.type = 'button';
    var del = el('button', 'fsbs-del', 'Remove'); del.type = 'button';
    head.appendChild(tog); head.appendChild(del); card.appendChild(head);
    var body = el('div', 'fsbs-lb'); card.appendChild(body);
    tog.onclick = function () { openCard(L, !card.classList.contains('open')); };
    del.onclick = function () { removeLayer(st, L); };
    var thumb = tog.querySelector('canvas');
    L.upd = function () {
      var same = st.layers.filter(function (x) { return x.type === L.type; }), title = (L.type === 'name' ? 'Name ' : 'Logo ') + (same.indexOf(L) + 1);
      tog.querySelector('.ln').textContent = title;
      del.setAttribute('aria-label', 'Remove ' + title.toLowerCase());
      var s;
      if (L.type === 'name') s = L.text ? L.text + ' · ' + (FONT_LABEL[L.font] || L.font) + ' · ' + cname(L.col) + (L.style === 'Embroidered' ? ' · Embroidered' : '') : 'Type a name';
      else s = L.file ? L.file.name + (L.style === 'Embroidered' ? ' · Embroidered' : '') : 'No file yet';
      tog.querySelector('.ls').textContent = s;
      if (thumb) {
        var im = L.rmbg && L.cut ? L.cut : L.img, tc = thumb.getContext('2d');
        thumb.style.display = im ? '' : 'none';
        tc.clearRect(0, 0, 64, 64);
        if (im) { var r = Math.min(56 / im.width, 56 / im.height), w = im.width * r, h = im.height * r; tc.drawImage(im, (64 - w) / 2, (64 - h) / 2, w, h); }
      }
    };
    list.appendChild(card);
    if (L.type === 'name') buildName(body, it, st, L); else buildLogo(body, it, st, L);
    L.upd();
    return card;
  }

  function buildName(body, it, st, L) {
    var inp = el('input'); inp.type = 'text'; inp.maxLength = 14; inp.placeholder = 'Type a name (max 14)'; inp.className = 'fsbs-text';
    inp.setAttribute('aria-label', 'Name text');
    inp.oninput = function () { L.text = inp.value.trim(); if (sel !== L) select(L); changed(); };
    body.appendChild(inp); L.input = inp;
    swatchGrid(body, 'Name Colour', function () { return L.col; }, function (v) { L.col = v; });
    pills(body, 'Name Font', FONTS.map(function (f) { return [f[0], f[1], '', f[0]]; }), function () { return L.font; }, function (v) { L.font = v; loadFont(v); }, 'fsbs-fonts');
    sizer(body, L, 'Name size', 40, 250);
    pills(body, 'Name Application', [['Print'], ['Embroidered', '', EMB_LABEL]], function () { return L.style; }, function (v) { L.style = v; });
  }

  function buildLogo(body, it, st, L) {
    var drop = el('label', 'fsbs-drop', '<span class="t">Drag and drop, or <b>browse</b></span><span class="s">PNG, JPG, JPEG, AI, EPS, PDF, HEIC</span><span class="f"></span>');
    var file = el('input'); file.type = 'file'; file.accept = '.png,.jpg,.jpeg,.webp,.ai,.eps,.pdf,.heic,.svg'; file.className = 'fsbs-file';
    file.setAttribute('aria-label', 'Upload a logo file');
    drop.appendChild(file); L.fileInput = file;
    var fname = drop.querySelector('.f'), lead = drop.querySelector('.t');
    body.appendChild(drop);
    body.appendChild(el('div', 'fsbs-tip', '(Tip: a PNG with a transparent background gives the most accurate preview.)'));
    var bgRow = el('label', 'fsbs-check', '<input type="checkbox" checked> Remove the background from my logo');
    bgRow.style.display = 'none';
    var note = el('div', 'fsbs-lnote');
    body.appendChild(bgRow); body.appendChild(note);
    function bgNote() {
      note.textContent = L.cut ? (L.rmbg ? 'We took out the background so only your logo shows on the ' + noun(it) + '. Untick the box if it removed part of your logo.' : 'Your logo will show with its background.') : '';
    }
    bgRow.querySelector('input').onchange = function (e) { L.rmbg = e.target.checked; bgNote(); select(L); changed(); };
    function setFile(f) {
      L.file = f || null; L.img = null; L.cut = null; L.loading = false;
      fname.textContent = f ? f.name : '';
      lead.innerHTML = f ? 'Drag and drop, or <b>browse</b> to replace' : 'Drag and drop, or <b>browse</b>';
      bgRow.style.display = 'none'; note.textContent = '';
      if (f) {
        if (canPreview(f)) {
          L.loading = true;
          loadLogo(f, function (res) {
            if (L.file !== f) return;
            L.loading = false;
            if (!res) note.textContent = "This file can't be shown on the preview, but we'll still get it with your order. Drag the box to where you want your logo, or upload a PNG or JPG to see it on your " + noun(it) + '.';
            else { L.img = res.img; L.cut = res.cut; bgRow.style.display = res.cut ? '' : 'none'; bgNote(); }
            changed();
          });
        } else {
          note.textContent = "This file type can't be shown on the preview, but we'll still get it with your order. Drag the box to where you want your logo, or upload a PNG or JPG to see it on your " + noun(it) + '.';
        }
        openCard(L, true);
      }
      changed();
    }
    file.onchange = function () { setFile(file.files[0]); };
    ['dragover', 'dragenter'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function () { drop.classList.remove('over'); }); });
    drop.addEventListener('drop', function (e) {
      e.preventDefault();
      if (e.dataTransfer.files && e.dataTransfer.files[0]) { try { file.files = e.dataTransfer.files; } catch (x) {} setFile(e.dataTransfer.files[0]); }
    });
    sizer(body, L, 'Logo size', 30, 250);
    pills(body, 'Logo Application', [['Print'], ['Embroidered', '', EMB_LABEL]], function () { return L.style; }, function (v) { L.style = v; });
  }

  function adder(list, it, st, type) {
    var b = el('button', 'fsbs-add'); b.type = 'button';
    b.onclick = function () {
      var L = newLayer(st, type);
      layerCard(list, it, st, L, false);
      openCard(L, true);
      changed();
      if (type === 'name') L.input.focus(); else L.fileInput.click();
    };
    REFRESH.push(function () {
      var n = st.layers.filter(function (x) { return x.type === type; }).length;
      b.textContent = '+ ' + (n ? 'Add another ' : 'Add a ') + type;
    });
    return b;
  }

  function buildItem(it, body) {
    var st = S[it.key];
    if (it.key === 'glove' && MODE === 'glove') {
      var bsub = sub(body, 'Base');
      bsub.appendChild(el('div', 'fsbs-tip', 'Choose the glove you want to start from.'));
      var brow = el('div', 'fsbs-bases');
      thumbs = [];
      BASES.forEach(function (b) {
        var bt = el('button', 'fsbs-base', '<canvas width="240" height="254" aria-hidden="true"></canvas><span>' + esc(b[1]) + '</span>');
        bt.type = 'button'; bt.setAttribute('data-v', b[0]); bt.setAttribute('aria-label', 'Base: ' + b[1]);
        bt.onclick = function () { setBase(b[0]); };
        thumbs.push({ key: b[0], cv: bt.querySelector('canvas'), done: false });
        brow.appendChild(bt);
      });
      bsub.appendChild(brow);
      REFRESH.push(function () { [].forEach.call(brow.children, function (x) { x.classList.toggle('on', x.getAttribute('data-v') === st.base); }); });
    }
    it.zones.forEach(function (z) {
      swatchGrid(body, z[1], function () { return st.c[z[0]]; }, function (v) { st.c[z[0]] = v; });
    });
    if (it.key === 'glove' && MODE === 'glove') {
      var xsub = sub(body, 'Cross Colours'); st.crossSub = xsub; xsub.style.display = 'none';
      xsub.appendChild(el('div', 'fsbs-tip', 'Pick a cross, then choose its colour.'));
      var act = CROSSES.crosses[0][0], xrow = el('div', 'fsbs-pills fsbs-xpills'), xgrid;
      var markX = function () {
        [].forEach.call(xrow.children, function (b) {
          var k = b.getAttribute('data-v');
          b.classList.toggle('on', k === act); b.querySelector('.fsbs-xdot').style.background = st.cc[k];
        });
      };
      CROSSES.crosses.forEach(function (x) {
        var b = el('button', 'fsbs-pill', '<i class="fsbs-xdot" aria-hidden="true"></i>' + esc(x[1]));
        b.type = 'button'; b.setAttribute('data-v', x[0]); b.setAttribute('aria-label', 'Cross: ' + x[1]);
        b.onclick = function () { act = x[0]; markX(); xgrid.mark(); };
        xrow.appendChild(b);
      });
      xsub.appendChild(xrow);
      xgrid = swatchGrid(xsub, 'Selected Cross Colour', function () { return st.cc[act]; }, function (v) { st.cc[act] = v; }, XSW);
      REFRESH.push(markX); markX();
    }
    if (it.key === 'glove') {
      var lg = sub(body, 'FiveStar Logo'); st.logoSub = lg;
      var chk = el('label', 'fsbs-check', '<input type="checkbox" checked> Show the FiveStar logo on the wrist');
      chk.querySelector('input').onchange = function (e) { st.fsbLogo = e.target.checked; changed(); };
      lg.appendChild(chk);
      swatchGrid(lg, 'Logo Colour', function () { return st.fsbLogoCol; }, function (v) { st.fsbLogoCol = v; });
    }
    var nm = sub(body, 'Add Your Name');
    nm.appendChild(el('div', 'fsbs-tip', 'Add as many names as you like. Drag each one on the picture to move it.'));
    var nlist = el('div', 'fsbs-layers'); nm.appendChild(nlist);
    nm.appendChild(adder(nlist, it, st, 'name'));
    layerCard(nlist, it, st, newLayer(st, 'name'), true);

    var up = sub(body, 'Upload Your Logo');
    up.appendChild(el('div', 'fsbs-tip', 'Add as many logos as you like. Drag each one on the picture to move it.'));
    var llist = el('div', 'fsbs-layers'); up.appendChild(llist);
    up.appendChild(adder(llist, it, st, 'logo'));
    up.appendChild(el('div', 'fsbs-disc', 'Only upload logos or artwork you own or have permission to use.'));
    layerCard(llist, it, st, newLayer(st, 'logo'), true);

    var sz = sub(body, 'Size');
    var sr = pills(sz, it.label + ' size', it.sizes.map(function (s) { return [s]; }), function () { return st.size; }, function (v) { st.size = v; sr.classList.remove('need'); });
  }

  function addGroup(title, sumFn, build, nextLabel) {
    var g = { wrap: el('div', 'fsbs-g') };
    var h = el('button', 'fsbs-gh', '<span class="t">' + esc(title) + '</span><span class="s"></span><span class="chev" aria-hidden="true"></span>');
    h.type = 'button';
    var body = el('div', 'fsbs-gb');
    g.wrap.appendChild(h); g.wrap.appendChild(body); ACC.appendChild(g.wrap);
    build(body);
    if (nextLabel !== null) {
      var nb = el('button', 'fsbs-next', (nextLabel || 'Done') + ' &#10003;'); nb.type = 'button';
      nb.onclick = function () { var i = groups.indexOf(g); open(i + 1 < groups.length ? i + 1 : -1); };
      body.appendChild(nb);
    }
    h.onclick = function () { open(g.wrap.classList.contains('open') ? -1 : groups.indexOf(g)); };
    g.sum = function () { h.querySelector('.s').innerHTML = sumFn(); };
    groups.push(g); g.sum();
    return g;
  }
  function open(i) {
    groups.forEach(function (g, j) { g.wrap.classList.toggle('open', j === i); });
    if (i >= 0) {
      var top = groups[i].wrap.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.6) groups[i].wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  var thumbs = null;
  function setBase(k) {
    var st = S.glove;
    if (!st || st.base === k) return;
    st.base = k;
    if (st.crossSub) st.crossSub.style.display = k === 'crosses' ? '' : 'none';
    if (st.logoSub) st.logoSub.style.display = k === 'crosses' ? 'none' : '';
    changed();
  }
  // small previews on the Base buttons, drawn once their images have loaded
  function drawThumbs() {
    if (!thumbs) return;
    thumbs.forEach(function (t) {
      if (t.done) return;
      var c = t.cv.getContext('2d'), W = t.cv.width, H = t.cv.height, s, w, h, ox, oy;
      if (t.key === 'classic' && gloveReady) {
        var cr = GLOVE.crop; s = Math.min((W - 16) / cr[2], (H - 16) / cr[3]); w = cr[2] * s; h = cr[3] * s;
        c.fillStyle = '#ffffff'; c.fillRect(0, 0, W, H);
        c.drawImage(IMG.det, cr[0], cr[1], cr[2], cr[3], (W - w) / 2, (H - h) / 2, w, h);
        t.done = true;
      } else if (t.key === 'flat' && flatReady) {
        var wf = {};
        s = Math.min((W - 16) / FLAT.tw, (H - 16) / FLAT.th); w = FLAT.tw * s; h = FLAT.th * s; ox = (W - w) / 2; oy = (H - h) / 2;
        ['glove_top', 'palm', 'outer_thumb', 'inner_thumb', 'wrist', 'trim'].forEach(function (z) { wf[z] = '#ffffff'; });
        c.fillStyle = '#ffffff'; c.fillRect(0, 0, W, H);
        c.save(); c.setTransform(s, 0, 0, s, ox, oy); drawFlat(c, wf, ''); c.restore();
        t.done = true;
      } else if (t.key === 'crosses' && crossReady) {
        var C = CROSSES, white = {}, cc = {};
        s = Math.min((W - 16) / C.tw, (H - 16) / C.th); w = C.tw * s; h = C.th * s; ox = (W - w) / 2; oy = (H - h) / 2;
        ['glove_top', 'palm', 'outer_thumb', 'inner_thumb', 'wrist', 'trim'].forEach(function (z) { white[z] = '#ffffff'; });
        C.crosses.forEach(function (x) { cc[x[0]] = x[2]; });
        c.fillStyle = '#ffffff'; c.fillRect(0, 0, W, H);
        c.save(); c.setTransform(s, 0, 0, s, ox, oy); drawCrosses(c, white, cc); c.restore();
        t.done = true;
      }
    });
  }

  ITEMS.forEach(function (it, idx) {
    var next = idx < ITEMS.length - 1 ? 'Next: ' + ITEMS[idx + 1].title : 'Next: Confirm Design';
    it.group = addGroup(it.title, function () {
      var st = S[it.key];
      var dots = it.zones.map(function (z) { return '<i style="background:' + st.c[z[0]] + '"></i>'; }).join('');
      var bits = [], names = [], logos = 0;
      st.layers.forEach(function (L) { if (L.type === 'name' && L.text) names.push(L.text); if (L.type === 'logo' && L.file) logos++; });
      if (MODE === 'glove' && st.base === 'crosses') bits.push('Crosses');
      if (MODE === 'glove' && st.base === 'flat') bits.push('Flat Wrist');
      if (names.length) bits.push(esc(names.join(', ')));
      if (logos) bits.push(logos > 1 ? logos + ' logos' : 'Logo');
      bits.push(st.size ? esc(st.size) : '<em>Choose size</em>');
      return '<span class="dots">' + dots + '</span>' + bits.join(' &middot; ');
    }, function (body) { buildItem(it, body); }, next);
  });

  addGroup('Confirm Design', function () { return META.agree ? 'Agreed' : ''; }, function (body) {
    var n = sub(body, 'Additional Notes / Instructions');
    var ta = el('textarea', 'fsbs-text'); ta.rows = 3; ta.placeholder = 'Anything we should know about your order...';
    ta.oninput = function () { META.notes = ta.value.trim(); };
    n.appendChild(ta);
    var cf = sub(body, 'Important Notice');
    var lab = el('label', 'fsbs-notice', '<input type="checkbox"><span>I understand my custom gear will take around 4-6 weeks to make and ship. Once my design is submitted it cannot be changed, refunded or returned unless a mistake was made on our part. A tracking number will be sent when my order is complete. Thank you for choosing FiveStarBoxing.</span>');
    lab.querySelector('input').onchange = function (e) { META.agree = e.target.checked; changed(); };
    cf.appendChild(lab);
  }, null);

  /* ---------- add to cart ---------- */
  var btn = document.getElementById('fsbs-add');
  var msg = document.getElementById('fsbs-msg');
  btn.onclick = function () {
    msg.textContent = '';
    for (var i = 0; i < ITEMS.length; i++) {
      if (!S[ITEMS[i].key].size) {
        msg.textContent = 'Please choose a ' + ITEMS[i].label.toLowerCase() + ' size.';
        open(groups.indexOf(ITEMS[i].group));
        var need = ITEMS[i].group.wrap.querySelectorAll('.fsbs-sub');
        var last = need[need.length - 1]; if (last) { last.querySelector('.fsbs-q').classList.add('need'); last.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        return;
      }
    }
    btn.disabled = true; btn.textContent = 'Adding...';
    hover = null; drag = null; sel = null; EXPORTING = true; render();
    var v = currentVariant();
    document.getElementById('fsbs-vid').value = v ? v.id : '';
    var props = {}, files = [], any = false;
    ITEMS.forEach(function (it) {
      var st = S[it.key], L = it.label;
      props[L + ' Size'] = st.size;
      it.zones.forEach(function (z) { props[L + ' ' + z[1]] = cname(st.c[z[0]]); });
      if (it.key === 'glove') {
        props['Gloves Laces'] = 'White';
        if (MODE === 'glove') props['Gloves Base'] = BASE_NAME[st.base] || BASE_NAME.classic;
        if (st.base === 'crosses') {
          props['Gloves FiveStar Logo'] = 'None';
          CROSSES.crosses.forEach(function (x) { props['Gloves Cross ' + x[1]] = cname(st.cc[x[0]]); });
        } else props['Gloves FiveStar Logo'] = st.fsbLogo ? cname(st.fsbLogoCol) : 'None';
      }
      if (it.key === 'head') props['Headgear Straps & Padding'] = 'Black';
      if (it.key === 'groin') props['Groin Guard Straps'] = 'Black';
      var names = st.layers.filter(function (x) { return x.type === 'name' && x.text; });
      var logos = st.layers.filter(function (x) { return x.type === 'logo' && x.file; });
      if (!names.length) props[L + ' Name'] = 'None';
      names.forEach(function (x, j) {
        props[L + ' Name' + (names.length > 1 ? ' ' + (j + 1) : '')] = x.text + ' (' + x.font + ', ' + cname(x.col) + ', ' + x.style + ')';
      });
      if (!logos.length) props[L + ' Logo'] = 'None';
      logos.forEach(function (x, j) {
        var k = L + ' Logo' + (logos.length > 1 ? ' ' + (j + 1) : '');
        props[k] = x.file.name + ' (' + x.style + (x.cut ? (x.rmbg ? ', remove background' : ', keep background') : '') + ')';
        files.push([k + ' File', x.file]);
      });
      if (names.length || logos.length) any = true;
    });
    if (any) props['Name & Logo Placement'] = 'As shown in the design preview';
    props['Embroidered Items'] = String(embCount());
    props['Notes'] = META.notes || 'None';
    props['Confirmed Notice'] = META.agree ? 'Yes' : 'No';
    var box = document.getElementById('fsbs-props'); box.innerHTML = '';
    Object.keys(props).forEach(function (k) {
      var inp = document.createElement('input'); inp.type = 'hidden'; inp.name = 'properties[' + k + ']'; inp.value = props[k]; box.appendChild(inp);
    });
    function addFile(name, f) {
      try { var inp = document.createElement('input'); inp.type = 'file'; inp.name = 'properties[' + name + ']'; var dt = new DataTransfer(); dt.items.add(f); inp.files = dt.files; box.appendChild(inp); } catch (e) {}
    }
    files.forEach(function (x) { addFile(x[0], x[1]); });
    function go() { form.submit(); }
    try {
      view.toBlob(function (blob) {
        if (blob) addFile('Design Preview', new File([blob], 'design-preview.png', { type: 'image/png' }));
        go();
      }, 'image/png');
    } catch (e) { go(); }
  };

  window.addEventListener('pageshow', function () { btn.disabled = false; btn.textContent = 'Add to cart'; EXPORTING = false; render(); });
  changed();
})();
